/* eslint-disable camelcase */
import React from 'react'
import { MRT_ColumnDef } from 'material-react-table'
import { TableData, useSchemaState } from 'contexts'
import { displayIsoDateAndTime, formatNullableBooleanAsYesNo } from 'utils/helpers/format'
import { ObservationPopUp } from 'components/common'
import { DateISO8601 } from 'models'
import ReserveInput from 'components/dataTable/ReserveInput'
import useGetCurrentCustomization from './useGetCurrentCustomization'
import useGetCurrentOrder from './useGetCurrentOrder'

const useGenerateColumns = () => {
  const { currentTableKey } = useSchemaState()
  const { currentCustomization } = useGetCurrentCustomization()
  const { order } = useGetCurrentOrder()

  const columns: MRT_ColumnDef<TableData, unknown>[] = order.map((property) => {
    const defaultCol = {
      accessorKey: property,
      id: property,
      header: currentCustomization[property]?.label || '',
    }
    switch (property) {
      case 'reserveTTCHF': {
        return currentTableKey === 'futureSalesDetail'
          ? {
              ...defaultCol,
              Cell: ({ ...row }) => {
                return (
                  <ReserveInput
                    value={(row.row.original.reserveTTCHF as number | null | undefined) ?? null}
                    licensePlate={row.row.original.licensePlate as unknown as string}
                    entityId={row.row.original.entityId as unknown as string}
                    vehicleNo={row.row.original.no as unknown as string}
                    key={row.row.original.no as unknown as string}
                  />
                )
              },
            }
          : defaultCol
      }
      case 'updateDateTime': {
        return {
          ...defaultCol,
          Cell: ({ ...row }) => {
            return displayIsoDateAndTime(row.row.original.updateDateTime as unknown as DateISO8601)
          },
        }
      }
      case 'observationsVendeur': {
        return {
          ...defaultCol,
          Cell: ({ ...row }) => {
            return <ObservationPopUp observation={row.row.original.observationsVendeur as string} />
          },
        }
      }
      case 'tvaRecuperable': {
        return {
          ...defaultCol,
          Cell: ({ ...row }) => {
            return formatNullableBooleanAsYesNo(
              row.row.original.tvaRecuperable as boolean | null | undefined,
            )
          },
        }
      }
      default:
        return defaultCol
    }
  })

  return columns
}

export default useGenerateColumns
